const NotFound = (): JSX.Element => <div>404: Page not found</div>;

export default NotFound;
